<template>
  <div id="room-details">
    <div class="room-tab">
      <div
        class="tab"
        :class="{ active: contentType === 'performance' }"
        @click="changeContentType('performance')"
      >
        Performance
      </div>
      <div
        class="tab"
        :class="{ active: contentType === 'communication' }"
        @click="changeContentType('communication')"
      >
        Communication
      </div>
      <div
        class="tab"
        :class="{ active: contentType === 'challenge' }"
        @click="changeContentType('challenge')"
      >
        Challenge
      </div>
    </div>
    <div class="contents">
      <comp-graph
        v-for="(content, pIdx) in getContent"
        :key="pIdx"
        :graphData="content"
      >
      </comp-graph>
      <div class="btn-back" @click="goBack">Go Back</div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import RoomService from '@/services/room-service'
import CompGraph from '@/components/CompGraph'

export default {
  name: 'RoomDetails',
  mixins: [common],
  components: {
    CompGraph
  },
  data() {
    return {
      roomSeqId: this.$route.params.roomSeqId,
      isLoading: false,

      contentType: 'performance',
      performanceList: [],
      communicationList: [],
      challengeList: []
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader(this.$route.query.roomName)
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)

    this.performGetRoomDetailInfo()
  },
  computed: {
    getContent() {
      switch (this.contentType) {
        case 'performance':
          return this.performanceList
        case 'communication':
          return this.communicationList
        case 'challenge':
          return this.challengeList
        default:
          return []
      }
    }
  },
  methods: {
    performGetRoomDetailInfo() {
      if (!this.roomSeqId) return
      this.isLoading = true

      RoomService.getRoomDetailInfo(this.roomSeqId).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0 && !this.isEmpty(resultData)) {
            this.performanceList = resultData.performance
            this.communicationList = resultData.communication
            this.challengeList = resultData.challenge
          }
        }
      )
    },
    changeContentType(contentType) {
      this.contentType = contentType
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/rooms.scss" scoped></style>
